angular.module("registrace", ['ngRoute', 'registraceServices', 'translation', 'common'])

.config(['$routeProvider',
	function($routeProvider) {
		$routeProvider.when('/registrace-simple', {
			templateUrl: 'registrace/tmpl/registrace-simple.tmpl.html',
			controller: 'RegistraceSimpleCtrl'
		});
		$routeProvider.when('/registrace-email-sent', {
			templateUrl: 'registrace/tmpl/registrace-email-sent.tmpl.html',
			controller: 'RegistraceEmailSentCtrl'
		});
		$routeProvider.when('/registrace', {
			templateUrl: 'registrace/tmpl/registrace.tmpl.html',
			controller: 'RegistraceCtrl'
		});
		$routeProvider.when('/dokonceni', {
			templateUrl: 'registrace/tmpl/registrace-dokonceni.tmpl.html',
			controller: 'RegistraceDokonceniCtrl'
		});
		$routeProvider.when('/ok', {
			templateUrl: 'registrace/tmpl/registrace-ok.tmpl.html',
			controller: 'RegistraceOkCtrl'
		});
		$routeProvider.otherwise({
			redirectTo: '/registrace-simple'
		});
	}
]);